export const DRAWER_WIDTH_OPEN = 300;
export const DRAWER_WIDTH_CLOSED = 60;
